<div
  style="display: flex; flex-direction: column; gap: 40px; align-items: center; justify-content: center; height: 100dvh; padding: 50px;"
>

  <img
    src="assets/images/logo.png"
    style="height: 100px;"
  >

  <div
    class="text-wrapper"
    style="max-width: 800px;"
  >
    Welcome to the Ruby Play Network page, presented by Xportal.
    <br>
    <br>
    As of April 9, 2024, the current platform has been decommissioned. But don’t worry! We’ve got you covered. You’ll
    receive an email by April 16 with further details. If you don’t receive the email or have any questions, feel free
    to reach out to us at <a href="mailto:support@rewards.rubyplaynetwork.com">support@rewards.rubyplaynetwork.com</a>.
    <br>
    <br>
    For new version of token services, head over to Ruby Play Network Rewards (<a
      href="https://rewards.rubyplaynetwork.com"
    >https://rewards.rubyplaynetwork.com</a>). We’re here to assist you on your crypto journey! 🚀⭐

  </div>

</div>